<template><section><html><head></head><body><h1>📚 神羊电子会计管理系统 更新日志</h1>
<h3>v1.0.0.1.20260723</h3>
<ul>
<li><strong>【新功能】</strong> 增加明细账页码位置的配置项。选择顶部时，奇数页在右上，偶数页在左上；选择底部时，在底部居中。</li>
</ul>
<h3>v1.0.0.1.20260710</h3>
<ul>
<li><strong>【调整】</strong> 时序账导出改为导出全部</li>
</ul>
<h3>v1.0.0.1.20260708</h3>
<ul>
<li><strong>【调整】</strong> 附件查看方式调整</li>
<li><strong>【新功能】</strong> 增加是否开启无纸化的配置项</li>
</ul>
<h3>v1.0.0.1.20260618</h3>
<ul>
<li><strong>【新功能】</strong> 凭证打印增加附件内容</li>
</ul>
<h3>v1.0.0.1.20260408</h3>
<ul>
<li><strong>【新功能】</strong> 断号检测提示具体缺少的凭证号</li>
</ul>
<h3>v1.0.0.1.20260303</h3>
<ul>
<li><strong>【新功能】</strong> 账套设置中增加明细账打印方向的设置</li>
</ul>
<h3>v1.0.0.1.20260211</h3>
<ul>
<li><strong>【新功能】</strong> 新增xlsx格式建行对账单的导入</li>
</ul>
<h3>v1.0.0.1.20260204</h3>
<ul>
<li><strong>【新功能】</strong> 新增带字母的科目导入</li>
</ul>
<h3>v1.0.0.1.20250813</h3>
<ul>
<li><strong>【新功能】</strong> 凭证列表增加断号检测</li>
</ul>
<h3>v1.0.0.1.20250220</h3>
<ul>
<li><strong>【新功能】</strong> 银行对账单增加导出功能</li>
</ul>
<h3>v1.0.0.1.20250220</h3>
<ul>
<li><strong>【新功能】</strong> 凭证编辑金额数字长度扩展到十亿</li>
<li><strong>【调整】</strong> 凭证附件排序跟随导入文件，增加序号显示</li>
</ul>
<h3>v1.0.0.1.20250126</h3>
<ul>
<li><strong>【新功能】</strong> 凭证查询增加记住显示顺序的功能</li>
</ul>
<h3>v1.0.0.1.20250122</h3>
<ul>
<li><strong>【调整】</strong> 本年累计的起始日期修改为结束日期当年的1月1日</li>
</ul>
<h3>v1.0.0.1.20241223</h3>
<ul>
<li><strong>【调整】</strong> 调整附件列表的展示方式</li>
</ul>
<h3>v1.0.0.1.20241211</h3>
<ul>
<li><strong>【新功能】</strong> 新增xls格式建行对账单的导入</li>
</ul>
<h3>v1.0.0.1.20241029</h3>
<ul>
<li><strong>【调整】</strong> 凭证编辑外币功能界面调整</li>
<li><strong>【新功能】</strong> 账套管理员可以重置其他用户的密码</li>
</ul>
<h3>v1.0.0.1.20241012</h3>
<ul>
<li><strong>【新功能】</strong> 增加外币功能</li>
</ul>
<h3>v1.0.0.1.20240823</h3>
<ul>
<li><strong>【新功能】</strong> 增加强密码功能</li>
</ul>
<h3>v1.0.0.1.20240803</h3>
<ul>
<li><strong>【调整】</strong> 明细账、日记账、外币日记账，本期合计后增加本年累计</li>
</ul>
<h3>v1.0.0.1.20240723</h3>
<ul>
<li><strong>【新功能】</strong> 增加凭证分录筛选功能</li>
</ul>
<h3>v1.0.0.1.20240624</h3>
<ul>
<li><strong>【新功能】</strong> 增加凭证附件功能</li>
</ul>
<h3>v1.0.0.1.20240523</h3>
<ul>
<li><strong>【新功能】</strong> 账套设置中新增凭证打印分录条数的配置</li>
<li><strong>【新功能】</strong> 凭证打印新增显示14条分录的模式</li>
</ul>
<h3>v1.0.0.1.20240514</h3>
<ul>
<li><strong>【新功能】</strong> 账套设置中新增凭证导入是否自动编号的配置</li>
</ul>
<h3>v1.0.0.1.20240510</h3>
<ul>
<li><strong>【调整】</strong> 调整凭证打印合计金额（大写金额为凭证总金额，小写金额为到当前页为止的累计金额）</li>
</ul>
<h3>v1.0.0.1.20240509</h3>
<ul>
<li><strong>【调整】</strong> 调整科目余额表显示顺序</li>
</ul>
<h3>v1.0.0.1.20240507</h3>
<ul>
<li><strong>【调整】</strong> 调整凭证打印顺序</li>
</ul>
<h3>v1.0.0.1.20240506</h3>
<ul>
<li><strong>【新功能】</strong> 新增凭证打印分页（A4）的配置项</li>
</ul>
<h3>v1.0.0.1.20240428</h3>
<ul>
<li><strong>【调整】</strong> 系统名称更改为“神羊电子会计管理系统”</li>
</ul>
<h3>v1.0.0.1.20240424</h3>
<ul>
<li><strong>【新功能】</strong> 增加更新日志功能</li>
<li><strong>【新功能】</strong> 增加区分凭证来源</li>
<li><strong>【新功能】</strong> 凭证查询中增加凭证来源的筛选</li>
<li><strong>【新功能】</strong> 余额调节表增加截止日期的筛选</li>
<li><strong>【调整】</strong> 调整凭证页面，打印所在分页页码的显示位置</li>
</ul>
<h3>v1.0.0.1.20240422</h3>
<ul>
<li><strong>【新功能】</strong> 凭证编辑界面增加删除功能</li>
<li><strong>【新功能】</strong> 凭证查询界面增加查询结果数据条数</li>
<li><strong>【新功能】</strong> 智能对账页面，对账单和银行账列表增加选中合计功能</li>
<li><strong>【新功能】</strong> 智能对账页面，对账单和银行账列表增加排序功能</li>
</ul>
</body></html></section></template>

